import { useEffect, useState } from 'react';
import { warehouseService } from 'services/api';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { userService } from 'services/api/UserService';
import { authActions } from 'features';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import {
  ROLE_SUPER_ADMIN,
  ROLE_TENANT_ADMIN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR
} from '../../constants';

export const WarehouseSelector = () => {
  const dispatch = useAppDispatch();
  const warehouse = useAppSelector((state) => state.auth.warehouse);
  const groups = useAppSelector((state) => state.auth.groups);
  const [warehouses, setWarehouses] = useState<string[]>([]);

  const canChangeWarehouse = Boolean(
    groups &&
      (groups.includes(ROLE_TENANT_TECHNICIAN_COORDINATOR) ||
        groups.includes(ROLE_TENANT_ADMIN) ||
        groups.includes(ROLE_SUPER_ADMIN))
  );

  useEffect(() => {
    if (!canChangeWarehouse) {
      return;
    }
    warehouseService
      .getAllBaseInformation()
      .then((res) => {
        if (res && Array.isArray(res)) {
          setWarehouses(res.map((wh) => wh.code));
        } else {
          setWarehouses([]);
        }
      })
      .catch(() => {
        setWarehouses([]);
      });
  }, [canChangeWarehouse]);

  const onChange = (_event: unknown, value: string | null) => {
    userService.selectWarehouse(value).then((res) => dispatch(authActions.selectWarehouse(res)));
  };

  if (!canChangeWarehouse) {
    if (!warehouse) {
      return null;
    }
    return (
      <div className="p-2 min-w-[200px] flex items-center gap-2">
        <WarehouseIcon color="primary" />
        <Typography variant="body2">{warehouse}</Typography>
      </div>
    );
  }

  return (
    <div className="p-2 min-w-[300px] flex items-center">
      <WarehouseIcon color="primary" />
      <Autocomplete
        className="flex-grow-1 w-full ml-3"
        multiple={false}
        disablePortal
        disableClearable={false}
        options={warehouses}
        onChange={onChange}
        value={warehouse ?? null}
        disabled={!warehouses.length}
        renderOption={(props, option) => {
          return (
            <Box component="li" {...props}>
              {option}
            </Box>
          );
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              fullWidth
              hiddenLabel={true}
              variant="standard"
              size="small"
              margin="none"
            />
          );
        }}
      />
    </div>
  );
};

export default WarehouseSelector;
